export enum CadenceTypesValues {
  ANNUALLY = 'ANNUALLY',
  MONTHLY = 'MONTHLY',
}

export const PRICE_PER_SEATS_ANNUALLY = 1620;
export const PRICE_PER_SEATS_MONTHLY = 150;
export const MONTHS_IN_A_YEAR = 12;

export const pricePerCadence = {
  [CadenceTypesValues.ANNUALLY]: PRICE_PER_SEATS_ANNUALLY,
  [CadenceTypesValues.MONTHLY]: PRICE_PER_SEATS_MONTHLY
};

export const cadenceNamePerCadence: Record<CadenceTypesValues, string> = {
  [CadenceTypesValues.ANNUALLY]: 'annual',
  [CadenceTypesValues.MONTHLY]: 'monthly'
};
